import {
  InputIcon,
  InputIconIconProp,
  InputIconVariant
} from '@platform/ui-library';
import {
  CSSProperties,
  FC,
  FormEvent,
  ReactElement
} from 'react';
import { FormControlProps, FormInputProps } from '@app/types';
import { ControlWithFormField, FormFieldControlProps } from './form-field';

export enum InputFieldType {
  password = 'password',
  text = 'text',
  textarea = 'textarea'
}

type InputIconExtras = {
  className?: string;
  description?: ReactElement | string;
  disabled?: boolean;
  extraClasses?: string;
  icon?: InputIconIconProp;
  required?: boolean;
  rows?: number;
  style?: CSSProperties;
  variant?: InputIconVariant | InputIconVariant[];
};

export type InputControlProps = (
  FormControlProps<string>
  & FormInputProps
  & InputIconExtras
  & {
    type?: InputFieldType;
  }
);

export const InputControl: FC<InputControlProps> = ({
  onChange,
  type = InputFieldType.text,
  value,
  ...inputIconProps
}) => (
  <InputIcon
    {...inputIconProps}
    onChange={(event: FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange(event.currentTarget.value);
    }}
    type={type}
    value={value ?? ''}
  />
);

export type InputProps = InputControlProps & FormFieldControlProps;

export const Input: FC<InputProps> = (props) => (
  <ControlWithFormField control={InputControl} {...props} />
);
